import { Suspense, lazy } from "react";
// components
import LoadingScreen from "../components/loading-screen";

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// ----------------------------------------------------------------------

export const LoginPage = Loadable(lazy(() => import("../pages/LoginPage")));
export const LandingPage = Loadable(lazy(() => import("../pages/LandingPage")));
export const Page404 = Loadable(lazy(() => import("../pages/Page404")));

// TODO: entries

// TODO: schools
export const SchoolList = Loadable(
  lazy(() => import("../pages/Entries/Schools/SchoolList"))
);

export const CreateSchool = Loadable(
  lazy(() => import("../pages/Entries/Schools/CreateSchool"))
);

export const ViewEditSchool = Loadable(
  lazy(() => import("../pages/Entries/Schools/ViewEditSchool"))
);

// TODO: dress
export const DressList = Loadable(
  lazy(() => import("../pages/Entries/Dresses/DressList"))
);

export const CreateDress = Loadable(
  lazy(() => import("../pages/Entries/Dresses/CreateDress"))
);

export const ViewEditDress = Loadable(
  lazy(() => import("../pages/Entries/Dresses/ViewEditDress"))
);

// TODO: sizes
export const SizeList = Loadable(
  lazy(() => import("../pages/Entries/Sizes/SizeList"))
);

export const CreateSize = Loadable(
  lazy(() => import("../pages/Entries/Sizes/CreateSize"))
);

// TODO: categories
export const CategoryList = Loadable(
  lazy(() => import("../pages/Entries/Categories/CategoryList"))
);

export const CreateCategory = Loadable(
  lazy(() => import("../pages/Entries/Categories/CreateCategory"))
);

// TODO: houses
export const HouseList = Loadable(
  lazy(() => import("../pages/Entries/Houses/HouseList"))
);

export const CreateHouse = Loadable(
  lazy(() => import("../pages/Entries/Houses/CreateHouse"))
);

// TODO: types
export const TypeList = Loadable(
  lazy(() => import("../pages/Entries/Types/TypeList"))
);

export const CreateType = Loadable(
  lazy(() => import("../pages/Entries/Types/CreateType"))
);

// TODO: products
export const ProductList = Loadable(
  lazy(() => import("../pages/Products/ProductsList"))
);

export const CreateProduct = Loadable(
  lazy(() => import("../pages/Products/CreateProducts"))
);

export const ViewEditProduct = Loadable(
  lazy(() => import("../pages/Products/ViewEditProduct"))
);

// TODO: orders
export const OrderList = Loadable(
  lazy(() => import("../pages/Orders/OrdersList"))
);

export const CreateOrder = Loadable(
  lazy(() => import("../pages/Orders/CreateOrder"))
);

export const ViewEditOrder = Loadable(
  lazy(() => import("../pages/Orders/ViewEditOrder"))
);

// TODO: products
export const ContactList = Loadable(
  lazy(() => import("../pages/Contacts/ContactList"))
);

export const CreateContact = Loadable(
  lazy(() => import("../pages/Contacts/CreateContact"))
);

// TODO: products
export const UserList = Loadable(
  lazy(() => import("../pages/Users/UsersList"))
);

export const CreateUser = Loadable(
  lazy(() => import("../pages/Users/CreateUser"))
);
